import { fg } from '@atlaskit/platform-feature-flags/fg';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';
import { PRODUCT_LIMITS_MAP } from './product-limits';

export function isEligibleForUserLimitDirectBuy(context: EditionAwarenessContextType): boolean {
	const { product, edition, isInCollection, licensedUsers, canUpgrade, canDirectBuyUpgrade } =
		context;
	const { warningUserLimit, licensedUserLimit } = PRODUCT_LIMITS_MAP.jira;

	return Boolean(
		isInCollection === 'NOT_IN_COLLECTION' &&
		isEditionOneOf(edition, ['free']) &&
		isProductOneOf(product, ['jira']) &&
		licensedUsers >= warningUserLimit &&
		licensedUsers <= licensedUserLimit &&
		// Include existing EA upgrade viewers, even when they cannot direct buy.
		(canUpgrade || canDirectBuyUpgrade) &&
		fg('twcg-2318_ea_user_limit_direct_buy_kill_switch'),
	);
}
